interface Props {
  /** Wordmark height in pixels. Default sized for sidebar / topbar use. */
  size?: number;
  /** Optional color override; defaults to brand ink. */
  tone?: "ink" | "paper";
}

export function BrandMark({ size = 22, tone = "ink" }: Props) {
  return (
    <span
      aria-label="Barose"
      style={{
        fontFamily: "var(--font-sans)",
        fontWeight: 900,
        letterSpacing: "-0.045em",
        lineHeight: 0.85,
        fontSize: `${size}px`,
        color: tone === "paper" ? "var(--brand-paper)" : "var(--brand-ink)",
        display: "inline-block",
        marginInlineStart: "-0.02em",
      }}
    >
      BAROSE
    </span>
  );
}
